import { render, staticRenderFns } from "./role-specific-route.vue?vue&type=template&id=141bf620&"
import script from "./role-specific-route.vue?vue&type=script&lang=ts&"
export * from "./role-specific-route.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports